import type { BridgeMcpToolCallResult, BridgeMcpToolContext } from '../../../bridge-mcp-tool-types.js';
import { fetchCloudParentSessionPrompts } from '../cloud/fetch-parent-prompts.js';
import { mcpTextResult } from './mcp-text-result.js';

export async function callListParentSessionPromptsTool(
  ctx: BridgeMcpToolContext,
  cloud: { cloudApiBaseUrl: string; getCloudAccessToken: () => string },
  childSessionId: string,
  parentSessionId: string,
): Promise<BridgeMcpToolCallResult> {
  const detail = await fetchCloudParentSessionPrompts({
    childSessionId,
    cloudApiBaseUrl: cloud.cloudApiBaseUrl,
    getCloudAccessToken: cloud.getCloudAccessToken,
    e2ee: ctx.e2ee,
  });
  if (!detail.ok) return mcpTextResult(detail.error, true);
  const turns = Array.isArray(detail.data.turns) ? detail.data.turns : [];
  const payload = turns.map((t) => ({
    turnId: typeof t.turnId === 'string' ? t.turnId : '',
    title: typeof t.title === 'string' ? t.title : null,
    status: typeof t.status === 'string' ? t.status : null,
    promptText: typeof t.promptText === 'string' ? t.promptText : null,
  }));
  return mcpTextResult(JSON.stringify({ parentSessionId, turns: payload }, null, 2));
}
